import React from 'react';
import { NavLink } from 'react-router-dom';
import SideNav from '@hig/side-nav';
import {
  FORGE_SCHEMA_REPOSITORY,
  NAME_FORGE_SCHEMA_LOCALIZATION_REPOSITORY,
} from '../../service/constants';

const isActive = (match, location) => {
  return match && match.url === location.pathname;
};

export const Sidebar = () => (
  <div className="sidebar">
    <SideNav
      headerLabel="Schema Lookup"
      headerLink="https://www.autodesk.com"
      superHeaderLabel="Autodesk"
      superHeaderLink="https://www.autodesk.com"
      // onClickSuperHeader={onClick}
      groups={
        <SideNav.Group>
          <SideNav.Module title="Forge Schema">
            <ul>
              <li>
                <NavLink isActive={isActive} to="/fsbrowserstg">
                  Published Schema (FSS) Browser - Staging
                </NavLink>
              </li>
              <li>
                <NavLink isActive={isActive} to="/fsbrowserprod">
                  Published Schema (FSS) Browser - Production
                </NavLink>
              </li>
            </ul>
          </SideNav.Module>
          <SideNav.Module title="UPS Schema">
            <ul>
              <li>
                <NavLink isActive={isActive} to="/">
                  UPS (GitHub - {FORGE_SCHEMA_REPOSITORY}) Browser
                </NavLink>
              </li>
              <li>
                <NavLink isActive={isActive} to="/schemalocals">
                  UPS Localization (GitHub - {NAME_FORGE_SCHEMA_LOCALIZATION_REPOSITORY}) Browser
                </NavLink>
              </li>
            </ul>
          </SideNav.Module>
          {/* <SideNav.Module title="Test Schema">
            <ul>
              <li>
                <NavLink isActive={isActive} to="/testschema">
                  Test Schema (GitHub - Test) Browser
                </NavLink>
              </li>
            </ul>
          </SideNav.Module> */}
        </SideNav.Group>
      }
    />
  </div>
);

export default Sidebar;
